import * as React from "react";
import {Fragment} from "react";
import UserMentionNotification from "../../../model/notification/mention/UserMentionNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: UserMentionNotification
}

/**
 * Lead status notification toast body.
 */
const NotificationUserMentionBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Lead {props.notification.data.referenceNumber}</div>
			<div className={"toast-body"}>
				You are mentioned in <strong>{props.notification.data.referenceNumber}</strong>
			</div>
		</Fragment>
	);
};

export default NotificationUserMentionBody;